import { render, staticRenderFns } from "./BarChartComparison.vue?vue&type=template&id=8dbbe2dc&scoped=true&"
import script from "./BarChartComparison.vue?vue&type=script&lang=js&"
export * from "./BarChartComparison.vue?vue&type=script&lang=js&"
import style0 from "./BarChartComparison.vue?vue&type=style&index=0&id=8dbbe2dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbbe2dc",
  null
  
)

export default component.exports